import api from '../config/api';

const discountService = {
  // Product Discounts
  async getProductDiscounts() {
    const response = await api.get('/api/discounts/products');
    return response.data;
  },

  async createProductDiscount(discountData) {
    const response = await api.post('/api/discounts/products', discountData);
    return response.data;
  },

  async updateProductDiscount(id, discountData) {
    const response = await api.put(`/api/discounts/products/${id}`, discountData);
    return response.data;
  },

  async deleteProductDiscount(id) {
    const response = await api.delete(`/api/discounts/products/${id}`);
    return response.data;
  },

  // Shipping Discounts
  async getShippingDiscounts() {
    const response = await api.get('/api/discounts/shipping');
    return response.data;
  },

  async createShippingDiscount(discountData) {
    const response = await api.post('/api/discounts/shipping', discountData);
    return response.data;
  },

  async updateShippingDiscount(id, discountData) {
    const response = await api.put(`/api/discounts/shipping/${id}`, discountData);
    return response.data;
  },

  async deleteShippingDiscount(id) {
    const response = await api.delete(`/api/discounts/shipping/${id}`);
    return response.data;
  },

  // Promotion Announcements
  async getPromotionAnnouncements() {
    const response = await api.get('/api/discounts/promotions');
    return response.data;
  },

  async createPromotionAnnouncement(promotionData) {
    const response = await api.post('/api/discounts/promotions', promotionData);
    return response.data;
  },

  async updatePromotionAnnouncement(id, promotionData) {
    const response = await api.put(`/api/discounts/promotions/${id}`, promotionData);
    return response.data;
  },

  async deletePromotionAnnouncement(id) {
    const response = await api.delete(`/api/discounts/promotions/${id}`);
    return response.data;
  },
};

export default discountService;
